import { render } from "./EditarUsuario.vue?vue&type=template&id=522fd50a"
import script from "./EditarUsuario.vue?vue&type=script&lang=js"
export * from "./EditarUsuario.vue?vue&type=script&lang=js"

import "./EditarUsuario.vue?vue&type=style&index=0&id=522fd50a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__